module.exports = __webpack_public_path__ + "static/media/D00.7b5e68d0.svg";